import FroalaEditor from 'froala-editor'
// Define popup template.
FroalaEditor.POPUP_TEMPLATES["customPlugin.popup"] = '[_BUTTONS_][_CUSTOM_LAYER_]';
// Define popup buttons.
Object.assign(FroalaEditor.DEFAULTS, {
    popupButtons: ['popupClose', '|', 'popupButton1'],
});
// The custom popup is defined inside a plugin (new or existing).
FroalaEditor.PLUGINS.customPlugin = function (editor) {
    // Create custom popup.
    function initPopup() {
        // Popup buttons.
        var popup_buttons = '';
        // Create the list of buttons.
        if (editor.opts.popupButtons.length > 1) {
            popup_buttons += '<div class="fr-buttons">';
            popup_buttons += editor.button.buildList(editor.opts.popupButtons);
            popup_buttons += '</div>';
        }
        // Load popup template.
        var template = {
            buttons: '<div class="fr-input-line" style="padding:1em;"><input type="text" value="" class="fr-link-attr" id="anchor-input" placeholder="" tabindex="1" dir="auto"><label for="fr-link-insert-layer-url-1">Anchor</label></div>',
            custom_layer: popup_buttons
        };
        // Create popup.
        var $popup = editor.popups.create('customPlugin.popup', template);
        return $popup;
    }
    // Show the popup
    function showPopup() {
        // Get the popup object defined above.
        var $popup = editor.popups.get('customPlugin.popup');
        // If popup doesn't exist then create it.
        // To improve performance it is best to create the popup when it is first needed
        // and not when the editor is initialized.
        if (!$popup) $popup = initPopup();
        // Set the editor toolbar as the popup's container.
        editor.popups.setContainer('customPlugin.popup', editor.$tb);
        // This will trigger the refresh event assigned to the popup.
        // editor.popups.refresh('customPlugin.popup');
        // This custom popup is opened by pressing a button from the editor's toolbar.
        // Get the button's object in order to place the popup relative to it.
        var $btn = editor.$tb.find('.fr-command[data-cmd="customLink"]');
        // Set the popup's position.
        var left = $btn.offset().left + $btn.outerWidth() / 2;
        var top = $btn.offset().top + (editor.opts.toolbarBottom ? 10 : $btn.outerHeight() - 10);
        // Show the custom popup.
        // The button's outerHeight is required in case the popup needs to be displayed above it.
        editor.popups.show('customPlugin.popup', left, top, $btn.outerHeight());
        document.getElementById("anchor-input").value = '';
    }
    // Hide the custom popup.
    function hidePopup() {
        editor.popups.hide('customPlugin.popup');
    }
    // Methods visible outside the plugin.
    return {
        showPopup: showPopup,
        hidePopup: hidePopup
    }
}
// Define an icon and command for the button that opens the custom popup.
FroalaEditor.DefineIcon('buttonIcon', { NAME: 'star', SVG_KEY: 'anchors' })
FroalaEditor.RegisterCommand('customLink', {
    title: 'Anchor',
    icon: 'buttonIcon',
    undo: true,
    focus: true,
    refreshAfterCallback: true,
    plugin: 'customPlugin',
    callback: function () {
        this.customPlugin.showPopup();
    }
});
// Define custom popup close button icon and command.
FroalaEditor.DefineIcon('popupClose', { NAME: 'times', SVG_KEY: 'close' });
FroalaEditor.RegisterCommand('popupClose', {
    title: 'Close',
    undo: true,
    focus: true,
    refreshAfterCallback: true,
    callback: function () {
        this.customPlugin.hidePopup();
    }
});
// Define custom popup 1.
FroalaEditor.DefineIcon('popupButton1', { NAME: 'bell-o', SVG_KEY: 'add' });
FroalaEditor.RegisterCommand('popupButton1', {
    title: 'Add',
    undo: true,
    focus: true,
    refreshAfterCallback: true,
    callback: function () {
        let str = document.getElementById("anchor-input").value;
        if (str) {
            var res = str.replace(/ /g, "");
            this.html.insert('<a id="' + res + '"></a>');
        }
        this.customPlugin.hidePopup();
    }
});
var frHztalBlockOptions = {
    7: "<div id='img-7' class='img-div' title='6 blocks'></div>",
    6: "<div id='img-6' class='img-div' title='6 blocks'></div>",
    5: "<div id='img-5' class='img-div' title='5 blocks'></div>",
    4: "<div id='img-4' class='img-div' title='4 blocks'></div>",
    3: "<div id='img-3' class='img-div' title='3 blocks'></div>"
};
var frHztalCallbackWrap = function (cmd, val) {
    var i;
    var html = '<div class="row px-3" style="background: none; border-collapse: collapse; border: none;" border="1" width="100%" cellspacing="0" cellpadding="0">'
    for (i = 0; i < val; i++) {
        let counter = i + 1;
        html +=
            `<div class="col-md horizontal-box-card px-1 pb-1" style="min-height: 100px;cursor:pointer;">
        <a href="#" class="horizontal-box-link py-3" style="vertical-align: middle !important; color: var(--secondary-color);
        text-decoration: none !important;text-align: center;font-weight: bold;top:0;left:0;right:0;bottom:0;border: solid var(--secondary-color) 1pt;
        height: 100%;width: 100%;display: flex;justify-content: center;align-items:center;">`+ counter + `</a>
      </div>`
    }
    html += "</div><p><br></p>";
    return html;
}
FroalaEditor.DefineIcon('horizontalBlocksIcon', { NAME: 'ellipsis-h', SVG_KEY: 'row' });
// Define a dropdown button.
FroalaEditor.RegisterCommand('horizontalBlocks', {
    // Button title.
    title: 'Horizontal Blocks',
    // Mark the button as a dropdown.
    type: 'dropdown',
    // Specify the icon for the button.
    // If this option is not specified, the button name will be used.
    icon: 'horizontalBlocksIcon',
    // Options for the dropdown.
    options: frHztalBlockOptions,
    // Save the dropdown action into undo stack.
    undo: true,
    // Focus inside the editor before callback.
    focus: true,
    // Callback.
    callback: function (cmd, val, params) {
        this.html.insert(frHztalCallbackWrap(cmd, val));
        // this.undo.saveStep();
    },
    // Called when the dropdown is shown.
    refreshOnShow: function (btn, dropdown) {
        // The current context is the editor instance.
        //console.log (this.selection.element());
        dropdown.find("a.fr-command").removeAttr("title");
        dropdown.find(".fr-dropdown-wrapper").css('max-height', '600px');
        dropdown.find(".fr-dropdown-content").css('max-height', '600px');
    }
});